import uploadCsv from "./uploadCsv";
import downloadCsv from "./downloadCsv";
import {stringify} from "csv-stringify/lib/sync";

class Builder {
    constructor() {
        this.validatorHtml = ''
        this.defaultsHtml = ''
        this.valuesHtml = ''
        this.descriptionHtml = ''
    }

    static _textInput(name) {
        return `<input type="text" name="${name}" class="">`
    }

    static _list(name, style) {
        return `<div class="multi-values multi-values-widget" data-name="${name}">
            <button type="button" class="btn btn-link" name="upload"><svg viewBox="0 0 20 20" aria-hidden="true"><use xlink:href="#icon-upload"></use></svg>${translate.optionForm.upload}.CSV</button>
            <button type="button" class="btn btn-link" name="download"><svg viewBox="0 0 20 20" aria-hidden="true"><use xlink:href="#icon-download"></use></svg>${translate.optionForm.download}.CSV</button>
            <ul class="values_content ${style}">
                <template><li><input type="text" class="" name="${name}[]" value="" placeholder="${window.translate.optionForm.placeholder_addOption}" /><svg viewBox="0 0 27 27" data-action="remove-line"><title>Edit</title><use xlink:href="#icon-close"></use></svg></li></template>
            </ul>
        </div>`
    }

    static _checkbox(name) {
        return `<label class="coing-switcher"><input type="checkbox" name="${name}" value=""><span class="slider"></span></label>`
    }

    static _dropdown(name, multi = false) {
        const multipleAttr = multi ? 'multiple' : '';
        return `<select name="${name}" class="form-control" ${multipleAttr}></select>`
    }

    static _colors(name) {
        return `<div class="color-picker" data-name="${name}">
            <div class="header">
                <div>${translate.optionForm.colorTable.label}</div>
                <div>${translate.optionForm.colorTable.color}</div>
                <div>${translate.optionForm.colorTable.remark}</div>
                <div></div>
            </div>
            <ul data-template="#ColorPickerTemplate">            
                <template id="ColorPickerTemplate">
                    <li class="marker-item" data-subitems-container>
                        <input type="hidden" name="${name}[]" data-master>
                        <div class="marker-label"><input type="text" name="item-label" placeholder="Label" data-subitem="label"></div>
                        <div class="marker-color"><input type="color" name="item-color" data-subitem="color"></div>
                        <div class="marker-remark"><input type="text" name="item-remark" placeholder="Remark" data-subitem="remark"></div>
                        <div class="marker-delete"><a class="delete" href="#" data-action="remove-line"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></a></div>
                    </li>
                </template>
            </ul>
        </div>`
    }

    setDefaultControl(callback, ...args) {
        const control = $(callback('default', ...args))
        // text or dropdown
        if (control[0].nodeName === 'select') {
            control.prepend('<option value="" disabled selected>${translate.optionForm.placeholder_default}</option>')
        } else {
            control.attr('placeholder', translate.optionForm.placeholder_default)
        }
        this.defaultsHtml = `<div class="ticket-row defaults-container">${control.prop('outerHTML')}</div>`
        return this
    }

    setValuesControl(callback, name, ...args) {
        // normal list or tags or colors
        this.valuesHtml = callback(name, ...args)
        return this
    }

    setValidatorControl() {
        this.validatorHtml = `<div class="ticket-row validator-container">
            <select class="form-control" name="text_validator">
                <option value="" disabled selected>${translate.optionForm.placeholder_insertType}</option>
                <option value="string">Text (Default)</option>
                <option value="number">Number</option>
            </select>
        </div>`
        return this
    }

    addDescriptionControl() {
        this.descriptionHtml = `<textarea class="form-control" name="long_description" rows="2" placeholder="${translate.optionForm.placeholder_description}"></textarea>`
        return this
    }

    html(key) {
        return `<div class="edit-option-form">
<!--<button type="button" class="close show-option"><span><svg class="svg-sprite window-close" viewBox="0 0 15 15" aria-label="Close"><title>Close</title><use xlink:href="#icon-close"></use></svg></span></button>-->
<input type="hidden" class="" name="label" maxlength="255">
<input type="hidden" class="" name="sort">
${this.descriptionHtml}
${this.valuesHtml}
${this.defaultsHtml}
${this.validatorHtml}
<div class="ticket-row control-mandatory"><div class="col-3"><span class="slider">${translate.optionForm.label_mandatory}</span></div><div class="col-3"><label class="coing-switcher mandatory"><input type="checkbox" name="force" value="1"><span class="slider"></span></label></div></div>
<div class="ticket-row control-admin-only"><div class="col-3"><span class="slider">${translate.optionForm.label_adminOnly}</span></div><div class="col-3"><label class="coing-switcher"><input type="checkbox" class="show-admin-switcher" name="show_admin" value="1"><span class="slider"></span></label></div></div>
<input type="hidden" name="show" value="1">
<button type="button" class="apply">${translate.optionForm.button_apply}</button>
</div>`
    }

    static textOption(key) {
        // return (new Builder()).setDefaultControl(Builder._textInput).setValidatorControl().html(key)
        return (new Builder())
            .addDescriptionControl()
            .setDefaultControl(Builder._textInput)
            .setValidatorControl()
            .html(key)
    }

    static multiChoiceOption(key) {
        return (new Builder())
            .setValuesControl(Builder._list, 'values', 'squared')
            .setDefaultControl(Builder._dropdown, false)
            .setValidatorControl()
            .addDescriptionControl()
            .html(key)
    }

    static singleChoiceOption(key) {
        return (new Builder())
            .addDescriptionControl()
            .setValuesControl(Builder._list, 'values', 'numbered')
            .setDefaultControl(Builder._dropdown, false)
            .setValidatorControl()
            .html(key)
    }

    static simpleOption(key) {
        return (new Builder()).addDescriptionControl().html(key)
    }

    static minimalOption(key) {
        return (new Builder()).html(key)
    }

    static boolOption(key) {
        return (new Builder()).setDefaultControl(Builder._checkbox).addDescriptionControl().html(key)
    }

    static tagsOption(key) {
        return (new Builder()).html(key)
    }

    static colorPicketOption(key) {
        return (new Builder()).setValuesControl(Builder._colors, 'table_values').html(key)
    }

}

class Values {
    constructor(owner) {
        this.owner = owner
        this._init()
        this._initEventHandlers()
        this._ensureEmpty()
    }

    _init()
    {
        this.$ = this.owner.$.find('[data-name="values"] .values_content')
        this.template = this.$.find('template').html()
    }

    _initEventHandlers()
    {
        const instance = this
        this.$.on('keyup', 'input', () => this._ensureEmpty())
        this.$.on('blur', 'input', () => {
            this.removeEmpty();
            this.owner.regenDefaults()
        })
        this.$.on('click', 'svg[data-action="remove-line"]', function () {
            $(this).closest('li').remove()
            instance._ensureEmpty()
            return false
        })
        this.$.parent().on('click', 'button[name="upload"]', () => {
            uploadCsv(
                row => this.addValue(row[0]),
                () => this.$.children('*:not(template)').remove(),
                () => this._ensureEmpty()
            )
            this.removeEmpty()
            owner.regenDefaults()
            return false
        })
        this.$.parent().on('click', 'button[name="download"]', () => {
            downloadCsv(stringify(this.getValues()))
            return false
        })
    }

    _ensureEmpty() {
        if (this._findEmpty().length === 0) {
            this.addValue('')
        }
    }

    _findEmpty(not = false) {
        return this.$.find('input').filter(function () {
            return not ? this.value != "" : this.value == ""
        })
    }

    removeEmpty() {
        this._findEmpty().each(function () {
            $(this).closest('li').remove()
        })
        this.addValue('')
    }

    addValue(value) {
        $(this.template).find('input').val(value || '').prevObject.appendTo(this.$)
    }

    setValues(values) {
        this.$.children('*:not(template)').remove()
        values.forEach(em => this.addValue(em))
        this._ensureEmpty()
    }

    getValues() {
        return this._findEmpty(true).get().map(e => [e.value])
    }
}

class ColorValues extends Values {

    _init() {
        this.$ = this.owner.$.find('.color-picker ul')
        this.template = this.$.find('template').html()
    }

    _initEventHandlers() {
        super._initEventHandlers();
        this.$.on('change', 'input[data-subitem]', function() {
            const name = $(this).data('subitem')
            const master = $(this).closest('[data-subitems-container]').find('input[data-master]')
            try {
                let value = JSON.parse(master.val())
                value[name] = $(this).val()
                master.val(JSON.stringify(value)) // no trigger
            } catch {
                console.warn(master.val() + ' is not a json')
            }
        })

        this.$.on('change', 'input[data-master]', function() {
            const items = $(this).closest('[data-subitems-container]').find('input[data-subitem]')
            try {
                JSON.parse($(this).val(), (key, value) => items.filter(`[data-subitem="${key}"]`).val(value))
            } catch (e) {
                console.warn($(this).val() + ' is not a json')
            }

        })
    }

    _findEmpty(not = false) {
        return this.$.find('input[data-subitem="label"]').filter(function () {
            return not ? this.value != "" : this.value == ""
        })
    }
    addValue(value) {
        $(this.template).appendTo(this.$).find('input[data-master]').val(value || {}).trigger('change')
    }
}

export class Form {
    constructor(options = {}) {
        const instance = this
        this.$storageField = options.field
        this.key = options.key
        this.type = options.type
        this.onHide = options.onHide
        this.$ = $(this.build(options.type))
        this.$.on('click', '.window-close', () => this.hide())
        this.$.on('click', 'button.apply', () => {
            this.updateValue()
            this.hide()
        })
        this.values = new Values(this)
        this.colors = new ColorValues(this)
        if (this.values.$.length) {
            // update defaults select for single-/multi- choices.
            this.valuesObserver = new MutationObserver(function (mutations) {
                for (const mutation of mutations) {
                    if (mutation.type === "childList") {
                        instance.regenDefaults()
                    }
                }
            })
            this.valuesObserver.observe(this.values.$[0], {childList: true})
        }
    }

    build(type) {
        const types = {
            // keys are from plus_details.yml form types.
            text: Builder.textOption,
            list: Builder.singleChoiceOption,
            bool: Builder.boolOption,
            simple: Builder.simpleOption,
            multilist: Builder.multiChoiceOption,
            document: Builder.simpleOption,
            date: Builder.simpleOption,
            minimal: Builder.minimalOption,
            colors: Builder.colorPicketOption,
        }
        console.debug(type)
        return types[type](this.key, this)
    }

    fill() {
        let data
        try {
            data = JSON.parse(this.$storageField.val())
        } catch (e) {
            console.warn(e)
            console.warn($(this).val())
            data = false
        }
        if (data) {
            if (data['skipsave'] === true) {
                // Community option. we can alter default values here.
                //
            }
            for (const [key, value] of Object.entries(data)) {
                if (key === 'default') {
                    this.regenDefaults()
                }
                if (Array.isArray(value)) {
                    if (key === 'values') {
                        this.values.setValues(value)
                    } else if (key === 'table_values') {
                        this.colors.setValues(value)
                    } else if (key === 'default') {
                        const input = this.$.find(`[name=${key}]`)
                        value.forEach(x => input.find(`[value="${x}"]`).attr('selected', true))
                    }
                } else {
                    const input = this.$.find(`[name=${key}]`)
                    if (input.length > 0) {
                        if (input.attr('type') === 'checkbox') {
                            input.attr('checked', !!parseInt(value))
                        } else {
                            input.val(value)
                        }
                        input.trigger('change')
                    }
                }
            }
        }
    }

    updateValue() {
        let result = {}
        // try {
        //     result = JSON.parse(this.$storageField.val())
        // } catch (e) {
        //     console.warn(e)
        //     console.warn($(this).val())
        //     result = {}
        // }
        this.$.find('input,select,textarea').not('[data-subitem]').each((i, em) => {
            const $this = $(em)
            const value = $this.attr('type') === 'checkbox' ? ($this.is(':checked') ? 1 : 0) : $this.val()
            let name = $this.attr('name')
            if (name.indexOf('[]') > -1) {
                name = name.slice(0, -2)
                if (typeof result[name] === 'undefined') {
                    result[name] = [value]
                } else {
                    if (value) {
                        result[name].push(value)
                    }
                }
            } else {
                result[name] = value
            }
        })
        result.skipsave = undefined
        result.show = (result.show_admin || 0) ? 0 : 1
        this.$storageField.val(JSON.stringify(result)).trigger('change')
    }

    regenDefaults() {
        const select = this.$.find('.defaults-container select')
        if (select.length > 0 && this.values.$.length > 0) {
            const values = this.values.getValues().map(e => e[0])
            values.push('')
            let existing = []
            select.find('option').each(function () {
                if (!values.includes($(this).attr('value'))) {
                    $(this).remove()
                } else {
                    existing.push($(this).attr('value'))
                }
            })
            values.filter(x => !existing.includes(x)).forEach(x => {
                select.append('<option value="' + x + '">' + x + '</option>')
            })
        }
    }

    show(parent) {
        this.fill()
        this.$.appendTo(parent)
    }

    hide() {
        this.$.detach()
        if (this.onHide) {
            this.onHide()
        }
    }
}
